import TransitApi from './base'

export default {
  async getAll(params = {}) {
    try {
      const Api = TransitApi.getSecureInstance()
      const queryString = TransitApi.getQueryString(params)
      const result = await Api.get(`/organo-anuente/list?${queryString}`)
      return result.data
    } catch (error) {
      return error.response
    }
  },

  async getBasicList() {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.get('/organo-anuente/basic-list')
      return result.data
    } catch (error) {
      return error.response
    }
  },

  async save(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const path = params.id
        ? `/organo-anuente/details/${params.id}`
        : '/organo-anuente/add'
      const result = await Api.post(path, params)
      return result
    } catch (error) {
      return error.response
    }
  },

  async delete(id) {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.delete(`/organo-anuente/${id}`)
      return result
    } catch (error) {
      return error.response
    }
  },
}
